export default __webpack_public_path__ + "static/media/white.649414a2.svg";